import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import useStyles from "./styles";
import Big from "big.js";
import { NUMBER_INPUT_ERR_MSG } from "../../constants";
import noop from "../../../services/noop";

const { RANGE_ERROR, VALIDNUM_ERROR, STEPSIZE_ERROR } = NUMBER_INPUT_ERR_MSG;

const NumberTextField = (props) => {
  const styles = useStyles(props);

  const clearError = () => {
    if (props.errMsg === STEPSIZE_ERROR) props.setError("");
  };

  const textfieldChangeHandler = (evnt) => {
    if (evnt.target.value !== "") {
      let val = Big(evnt.target.value).toNumber();
      props.setValue(val);
    }
  };

  const checkIsValid = (evnt) => {
    if (evnt.target.value !== "") {
      let val = Big(evnt.target.value);
      if (val.toNumber() >= props.min && val.toNumber() <= props.max) {
        const modValue = val.minus(props.min).mod(props.stepSize).toNumber();

        if (modValue !== 0) {
          props.setError(STEPSIZE_ERROR);
          if (modValue < props.stepSize - modValue) val = val.minus(modValue);
          else val = val.minus(modValue).plus(props.stepSize);

          if (val.toNumber() > props.max) val = val.minus(props.stepSize);
        }
        props.setValue(val.toNumber());
      } else {
        // props.addInvalidQuestion(props.questionId);
        props.setError(RANGE_ERROR);
      }
    }
  };

  return (
    <TextField
      type="number"
      variant="standard"
      className={`${styles.alignCenter} ${
        props.className ? props.className : ""
      }`}
      inputProps={{
        className: `${styles.numberInputText} ${
          props.errMsg === RANGE_ERROR || props.errMsg === VALIDNUM_ERROR
            ? styles.outlineRed
            : ""
        }`,
        step: props.stepSize,
        min: props.min,
        max: props.max,
        "data-testid": "number-textfield",
      }}
      InputProps={{
        disableUnderline: true,
      }}
      value={props.value}
      onKeyDown={(event) => {
        if (event.target.value === "") {
          props.setError(VALIDNUM_ERROR);
        }
        if (
          event.keyCode === 8 &&
          String(Math.abs(event.target.value)).length === 1
        ) {
          props.setValue("");
        }
      }}
      onChange={textfieldChangeHandler}
      onBlur={checkIsValid}
      onFocus={clearError}
      placeholder="00"
    />
  );
};

NumberTextField.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  stepSize: PropTypes.number,
  setError: PropTypes.func.isRequired,
  errMsg: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  // addInvalidQuestion: PropTypes.func.isRequired,
  // removeInvalidQuestion: PropTypes.func.isRequired,
};

NumberTextField.defaultProps = {
  min: 0,
  max: 100,
  stepSize: 1,
  setError: noop,
  errMsg: "",
  setValue: noop,
  // addInvalidQuestion: noop,
  // removeInvalidQuestion: noop,
  questionId: "",
};

export default NumberTextField;
